// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"c2145f3d7b716d2fd034","655":"62bf80393e9ebe608d28"}[chunkId] + ".js";
};